import actions from './actions';
import apps from './apps';
import companies from './companies';
import template from './template';
import configuration from './configuration';
import globalRoles from './globalRoles';
import webServices from './web-services';
import levels from './levels';
import promotions from './promotions';
import process from './process';

const route = {
	path: '/projects',
	name: 'page-project',
	meta: {
		title: 'Proyectos',
	},
	component: () => import('@/pages/projects/page-project'),
	children: [
		{
			path: 'new',
			name: 'page-project-new',
			meta: {
				title: 'Nuevo Proyecto',
			},
			component: () => import('@/pages/projects/page-project-new'),
		},
		{
			path: ':id/edit',
			name: 'page-project-edit',
			meta: {
				title: 'Editar Proyecto',
			},
			component: () => import('@/pages/projects/page-project-new'),
			props: true,
		},
		actions,
		apps,
		companies,
		configuration,
		globalRoles,
		template,
		webServices,
		process,
		levels,
		promotions,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/projects.js